import * as Sentry from '@sentry/react';
import React from 'react';
import { getRuntimeConfig } from './utils/runtimeConfig';
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router';
import { isDevelopment } from './utils';
export function initSentry() {
  const config = getRuntimeConfig();
  if (!config.VITE_SENTRY_DSN) return; // Optionally skip if DSN is not set

  Sentry.init({
    dsn: String(config.VITE_SENTRY_DSN ?? ''),
    environment: String(config.VITE_SENTRY_ENVIRONMENT ?? ''),
    release: String(config.VITE_SENTRY_RELEASE ?? ''),
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: isDevelopment() ? 1.0 : 0.1,
    debug: isDevelopment(),
    allowUrls: [
      window.location.origin,
      'localhost:5173',
      'localhost:4173',
      String(config.VITE_SENTRY_URL ?? ''),
    ],
  });
}
